<template>
  <div class="wrapper d-inline">
    <span class="badge text-uppercase font-weight mr-1 cursor-pointer" v-bind:class="getBadgeClass" v-on:click="show = !show">
      {{ getEventTypeText | uppercase }}
    </span>
    <additional-data :items="getItems" v-if="show" :received-at="getReceivedAt"></additional-data>
  </div>
</template>

<script>
import AdditionalData from "./additional-data";

const events = {
  1: 'badge-warning',
  2: 'badge-success',
  3: 'badge-success',
  4: 'badge-danger',
  5: 'badge-dark',
  6: 'badge-success',
  7: 'badge-success',
};

export default {
  props: {
    item: Object,
  },

  components: {
    AdditionalData,
  },

  data() {
    return {
      show: false,
    };
  },

  computed: {
    /**
     * @return {String}
     */
    getBadgeClass() {
      return _.get(events, this.item.type, 1);
    },

    /**
     * @return {String}
     */
    getEventTypeText() {
      return _.get(this.item, 'type_text');
    },

    /**
     * @return {Object}
     */
    getItems() {
      return _.get(this.item, 'data');
    },

    /**
     * @return {Object}
     */
    getReceivedAt() {
      return _.get(this.item, 'received_at');
    },
  },
}
</script>

<style scoped>

</style>
